export enum Types {
  SET_AUTHENTICATED = 'AUTH_SET_AUTHENTICATED',
  SET_USER = 'AUTH_SET_USER',
  UPDATE_USER = 'AUTH_UPDATE_USER',
  SET_EID = 'AUTH_SET_EID',
}

export type Action = SetAuthenticatedAction | SetUserAction | UpdateUserAction | SetEIDAction;

type SetAuthenticatedAction = {
  type: Types.SET_AUTHENTICATED;
  payload: {
    isAuthenticated: boolean;
    user: Api.User;
    crsPersoon?: Api.CrsPersoon;
  };
};

type SetUserAction = {
  type: Types.SET_USER;
  payload: Api.User;
};

type UpdateUserAction = {
  type: Types.UPDATE_USER;
  payload: Partial<Api.User>;
};

type SetEIDAction = {
  type: Types.SET_EID;
  payload: Api.eID;
};

export const setUser = (payload: Api.User): SetUserAction => ({
  type: Types.SET_USER,
  payload,
});

export const updateUser = (payload: Partial<Api.User>): UpdateUserAction => ({
  type: Types.UPDATE_USER,
  payload,
});

export const setAuthenticated = (data: any): SetAuthenticatedAction => ({
  type: Types.SET_AUTHENTICATED,
  payload: {
    isAuthenticated: data.isLoggedin,
    user: data.user?.dataSources.aprofiel,
    crsPersoon:
      Object.keys(data.user?.dataSources.crspersoon || {}).length > 0 &&
      data.user.dataSources.crspersoon,
  },
});

export const setEID = (payload: Api.eID): SetEIDAction => ({
  type: Types.SET_EID,
  payload,
});
